import BaseAbility from 'umg-ember-backend/abilities/base';

export default class PersonAbility extends BaseAbility {}
